import styled from "styled-components";

export const CategoryChartContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CategoryChartHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px 16px 24px;
`;

export const ChartBody = styled.div`
  display: flex;
`;

export const HighlightedText = styled.span`
  font-weight: 700;
  color: var(--hv-text-normal-secondary);
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
`;

export const TabsContainer = styled.div`
  width: 100%;
  margin: auto;
  padding: 0px 24px;
`;

export const TabContent = styled.div`
  padding: 18px 0px 20px 0px;
`;

export const ChartTableContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const ChartTable = styled.div`
  flex: 1;
`;

export const TableContainer = styled.div`
  display: flex;
  width: 100%;
  max-height: 320px;
  overflow-y: scroll;
`;

export const StatementContainer = styled.div`
  margin-top: 4px;
`;

export const HeaderText = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0%;
  color: var(--hv-text-normal-secondary);
`;

export const Text = styled.span<{ secondary?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0%;

  color: ${(props) =>
    props.secondary
      ? "var(--hv-text-normal-secondary)"
      : "var(--hv-text-normal-primary)"};
`;

export const LoaderContainer = styled.div`
  .skeleton {
    ::before {
      content: "";
      max-width: 100%;
    }
  }
`;
